// Create axios instance
import axios from 'axios'
// import moment from 'moment'

const service = axios.create({
  baseURL: process.env.VUE_APP_ENV_BASE_URL_API,
  timeout: 25000 // Request timeout
})
// Request intercepter
service.interceptors.request.use(
  (config) => {
    const storage = localStorage.getItem('remember') ? localStorage : sessionStorage
    const token = storage.getItem('token')
    if (token) {
      config.headers.Authorization = 'Bearer ' + token // Set JWT token
    }
    return config
  },
  (error) => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response pre-processing
service.interceptors.response.use(
  (response) => {
    // if (response.headers.authorization) {
    //   setLogged(response.headers.authorization);
    //   response.data.token = response.headers.authorization;
    // }

    return response.data
  },
  async (error) => {
    // begin check refresh token
    const originalConfig = error.config

    if (!originalConfig._retry && error.response?.status === 401) {
      originalConfig._retry = true
      try {
        const storage = localStorage.getItem('remember') ? localStorage : sessionStorage
        const tokenRefresh = storage.getItem('tokenRefresh')

        if (tokenRefresh) {
          const response = await service.post('/users/refresh-token', {
            refreshToken: tokenRefresh
          })

          if (response.success) {
            storage.setItem('token', response.token)
            storage.setItem('tokenExpired', response.tokenExpired)
          }
          return service(originalConfig)
        } else {
          if (!['/login', '/forgot-password', '/reset-password'].includes(window.location.pathname)) {
            if (window.location.pathname === '/callout/dial') {
              const params = new URLSearchParams(window.location.search)
              let phoneCti = null

              if (params.has('phoneCti')) {
                phoneCti = params.get('phoneCti')
                window.location.href = '/login?alert=true&phoneCti=' + phoneCti
              } else {
                window.location.href = '/login?alert=true'
              }
            }
          }
        }
      } catch (_error) {
        return Promise.reject(_error)
      }
    }
    // end check refresh token
    let message = error.message
    if (error.response?.data && error.response.data?.errors) {
      message = error.response.data.errors
    } else if (error.response?.data && error.response?.data.error) {
      message = error.response.data.error
    }
    console.log(message)

    return Promise.reject(error)
  }
)

export default service
